var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FeedbackLoop_instances, _FeedbackLoop_builder, _FeedbackLoop_injector, _FeedbackLoop_metadata, _FeedbackLoop_language, _FeedbackLoop_shouldShowForm;
import { ComponentType, FeedbackFormBuilder, FormCloseReason, } from '@wix/feedback-loop-structure';
import { shouldShowForm } from './api';
import { FeedbackLoopFrameInjector } from './inject';
export class FeedbackLoop {
    constructor(formId, { language, ...metadata }) {
        _FeedbackLoop_instances.add(this);
        this.formId = formId;
        _FeedbackLoop_builder.set(this, void 0);
        _FeedbackLoop_injector.set(this, new FeedbackLoopFrameInjector());
        _FeedbackLoop_metadata.set(this, void 0);
        _FeedbackLoop_language.set(this, void 0);
        __classPrivateFieldSet(this, _FeedbackLoop_builder, new FeedbackFormBuilder(this.formId), "f");
        __classPrivateFieldSet(this, _FeedbackLoop_metadata, metadata, "f");
        __classPrivateFieldSet(this, _FeedbackLoop_language, language || 'en', "f");
    }
    setTitle(title) {
        __classPrivateFieldGet(this, _FeedbackLoop_builder, "f").setTitle(title);
        return this;
    }
    addTextInput(id, cb) {
        __classPrivateFieldGet(this, _FeedbackLoop_builder, "f").addTextInput(id, cb);
        return this;
    }
    addDropdown(id, cb) {
        __classPrivateFieldGet(this, _FeedbackLoop_builder, "f").addDropdown(id, cb);
        return this;
    }
    addSegmentedToggle(id, cb) {
        __classPrivateFieldGet(this, _FeedbackLoop_builder, "f").addSegmentedToggle(id, cb);
        return this;
    }
    addFacesRatingBar(id, cb) {
        __classPrivateFieldGet(this, _FeedbackLoop_builder, "f").addFacesRatingBar(id, cb);
        return this;
    }
    async open(position) {
        if (!__classPrivateFieldGet(this, _FeedbackLoop_builder, "f").isValid()) {
            throw new Error('feedback-loop: form is not valid or not defined at all');
        }
        if (FeedbackLoopFrameInjector.isFeedbackFormIframeVisible()) {
            return Promise.resolve({
                reason: 'not-shown',
            });
        }
        if (await __classPrivateFieldGet(this, _FeedbackLoop_instances, "m", _FeedbackLoop_shouldShowForm).call(this)) {
            return __classPrivateFieldGet(this, _FeedbackLoop_injector, "f").open(__classPrivateFieldGet(this, _FeedbackLoop_builder, "f").build(), __classPrivateFieldGet(this, _FeedbackLoop_metadata, "f"), position, __classPrivateFieldGet(this, _FeedbackLoop_language, "f"));
        }
        else {
            return Promise.resolve({
                reason: 'not-shown',
            });
        }
    }
    async show() {
        __classPrivateFieldGet(this, _FeedbackLoop_injector, "f").show();
    }
    async hide() {
        __classPrivateFieldGet(this, _FeedbackLoop_injector, "f").hide();
    }
    async close() {
        __classPrivateFieldGet(this, _FeedbackLoop_injector, "f").close({
            reason: FormCloseReason.Closed,
            payload: [],
        });
    }
    _build() {
        return __classPrivateFieldGet(this, _FeedbackLoop_builder, "f").build();
    }
}
_FeedbackLoop_builder = new WeakMap(), _FeedbackLoop_injector = new WeakMap(), _FeedbackLoop_metadata = new WeakMap(), _FeedbackLoop_language = new WeakMap(), _FeedbackLoop_instances = new WeakSet(), _FeedbackLoop_shouldShowForm = async function _FeedbackLoop_shouldShowForm() {
    return shouldShowForm(this.formId);
};
export function createFeedbackLoop(formId, metadata) {
    return new FeedbackLoop(formId, metadata);
}
export function createFeedbackLoopFromStructure(metadata, structure) {
    const form = new FeedbackLoop(structure.id, metadata);
    form.setTitle(structure.title);
    const withDefaults = (builder, row) => {
        builder.setLabel(row.label);
        if (row.placeholder) {
            builder.setPlaceholder(row.placeholder);
        }
    };
    structure.components.forEach((row) => {
        switch (row.type) {
            case ComponentType.Dropdown: {
                const _row = row;
                form.addDropdown(_row.id, (builder) => {
                    withDefaults(builder, _row);
                    _row.options?.forEach((option) => {
                        builder.addOption(option.id, option.displayName);
                    });
                });
                break;
            }
            case ComponentType.TextInput: {
                const _row = row;
                form.addTextInput(_row.id, (builder) => {
                    withDefaults(builder, _row);
                });
                break;
            }
            case ComponentType.SegmentedToggle: {
                const _row = row;
                form.addSegmentedToggle(_row.id, (builder) => {
                    withDefaults(builder, _row);
                    const positive = _row.buttons?.find((button) => button.id === 'positive');
                    const negative = _row.buttons?.find((button) => button.id === 'negative');
                    if (positive) {
                        builder.setPositiveLabel(positive.displayName);
                    }
                    if (negative) {
                        builder.setNegativeLabel(negative.displayName);
                    }
                });
                break;
            }
            case ComponentType.FacesRatingBar: {
                const _row = row;
                form.addFacesRatingBar(_row.id, (builder) => {
                    withDefaults(builder, _row);
                    if (_row.tooltips && _row.tooltips.length) {
                        builder.setTooltips(_row.tooltips);
                    }
                });
                break;
            }
        }
    });
    return form;
}
//# sourceMappingURL=FeedbackLoop.js.map